module.exports = __webpack_public_path__ + "img/qd-img-3.4394e291.jpg";